import React from "react";
import ContactedPage from "./ContactedPage";

const PendingVisitsPage = () => {
  return (
    <div>
      <ContactedPage />
    </div>
  );
};

export default PendingVisitsPage;
